<script setup lang="ts">
import {computed,ref,watch} from 'vue'
const props=defineProps<{src?:string|null,name?:string}>()
const failed=ref(false)
const source=computed(()=>{try{const url=new URL(props.src||'',location.origin);return props.src&&['https:','http:'].includes(url.protocol)?url.href:''}catch{return ''}})
watch(()=>props.src,()=>failed.value=false)
</script>
<template><span class="profile-avatar"><img v-if="source&&!failed" :src="source" :alt="(name||'用户')+'的头像'" referrerpolicy="no-referrer" @error="failed=true"/><i v-else class="pi pi-user" aria-label="默认头像"/></span></template>
<style scoped>
.profile-avatar{display:inline-flex;width:32px;height:32px;flex:0 0 32px;border-radius:50%;overflow:hidden;align-items:center;justify-content:center;background:var(--soft);color:var(--muted)}.profile-avatar img{width:100%;height:100%;object-fit:cover;display:block}.profile-avatar i{font-size:16px}
</style>
